<template>
  <div class="haircolorDiagResult__container -absolute">
    <div v-if="product !== null" class="productTile hasTextCentered">
      <div class="productTile__wrapper">
        <div class="productTile__imageWrapper">
          <MediaImage
            :filename="product.image.fileName"
            :alt="product.image.alt"
            :resolutions="product.image.resolutions"
            :fallback-size="product.image.fallbackSize"
            :sizes="product.image.sizes"
            :aria-hidden="true"
            :format="product.image.format"
          >
          </MediaImage>
        </div>
        <div class="productTile__infoWrapper">
          <a :href="productUrl" target="_blank">
            <p class="productTile__brandName">{{ product.brand }}</p>
            <p class="productTile__productName">{{ product.name }}</p>
          </a>
        </div>
      </div>

      <div class="productTile__priceWrapper">
        <p class="productTile__price">{{ product.price }}</p>
      </div>

      <div class="productTile__ratings">
        <template v-if="product.ratingActivated">
          <div class="ratingsList">
            <OapRating :rating="product.rating" :rating-percentage="product.ratingPercentage" />
          </div>
        </template>
      </div>

      <a
        :class="['oap-button', 'oap-card__cta', product.buyNowUrl ? '-primary' : '-secondary']"
        :href="product.buyNowUrl ? product.buyNowUrl : productUrl"
      >
        <span class="oap-button__label">
          <!-- if there is a `buyNowUrl` entity that means the text in dictionary will be provided as well -->
          {{ product.buyNowUrl ? product.buyNowText : product.label }}
        </span>
      </a>
    </div>
  </div>
</template>

<script>
import MediaImage from '../../../../MediaImage/code/Scripts/components/MediaImage.vue';
import OapRating from '../../../../OapRating/code/Scripts/components/OapRating.vue';

export default {
  name: 'HaircolorDiagProductTile',

  components: {
    MediaImage,
    OapRating,
  },
  props: {
    product: { type: Object },
    productQuerystring: { type: String, required: false },
  },
  data() {
    return {
      productUrl: this.productQuerystring
        ? this.product.url + '?' + this.productQuerystring
        : this.product.url,
    };
  },
  settings: {
    ratings: 5,
  },
};
</script>
